module.exports = __webpack_public_path__ + "img/undraw_credit_card_re_blml.c5c97aad.png";